import SkRequest from './BaseRequest';
import { MutationBuilder } from '../queryBuilder';
import { FETCH_ALL_HOLIDAYS, FETCH_CLOSURE_DAYS } from './actionTypes';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { parseGraphQLError, actionHandlerWithFeatureFlag } from '../../utils';
import {
  GET_HOILDAY_CLOSURES,
  CREATE_HOLIDAY,
  UPDATE_HOLIDAY,
} from '../models/eventModels';
import { FEATURE_FLAGS } from '../../utils/constants';
import {
  msCreateHoliday,
  msFetchHolidays,
  msRemoveHoliday,
  msUpdateHoliday,
} from '../../services/CalendarService';
import DatadogHandler from '../../utils/datadog';

const fileName = 'src/redux/actions/HolidayManagement.js';
const _mMutationBuilder = new MutationBuilder();

_mMutationBuilder.setNewMutation('deleteHolidayDetails', {});
_mMutationBuilder.setNewMutation('getHolidayPhotoUploadURL', {
  Url: 'string',
  Key: 'string',
});

const dispatchHolidaysFetch = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_HOLIDAYS,
    key: 'holidays',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

const dipatchGetCentreClosureDays = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_CLOSURE_DAYS,
    key: 'closureDays',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoRemoveHoliday = (_, reqData) => {
  try {
    return SkRequest({
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'deleteHolidayDetails',
          reqData
        ),
      },
      method: 'POST',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoRemoveHoliday',
        fileName,
      },
      'error'
    );
    return {
      error: ex.message,
    };
  }
};

export const removeHoliday = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msRemoveHoliday,
      monoHandler: monoRemoveHoliday,
      extraData: reqData,
    }
  );
};

export const monoFetchHolidays = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_HOILDAY_CLOSURES,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (error) {
    DatadogHandler.addError(error);
    DatadogHandler.sendLog(
      error,
      {
        functionName: 'monoFetchHolidays',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error,
    };
  }
};

export const fetchHolidays =
  (reqData, key = 'list') =>
  async dispatch => {
    dispatchHolidaysFetch(dispatch, false, { key });
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msFetchHolidays,
        monoHandler: monoFetchHolidays,
        dispatch,
        extraData: reqData,
      }
    );

    if (data.success) {
      dispatchHolidaysFetch(dispatch, false, { data: data.data, key });
    } else {
      dispatchHolidaysFetch(dispatch, false, { key }, data.error);
    }

    return data;
  };

export const monoGetAllCentreClosureDays = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_HOILDAY_CLOSURES,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetAllCentreClosureDays',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: ex,
    };
  }
};

export const getAllCentreClosureDays = reqData => async dispatch => {
  dipatchGetCentreClosureDays(dispatch);
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchHolidays,
        monoHandler: monoGetAllCentreClosureDays,
        extraData: reqData,
      }
    );
    if (data.success) {
      dipatchGetCentreClosureDays(dispatch, false, { data: data.data });
    } else {
      dipatchGetCentreClosureDays(dispatch, false, null, data.error);
    }
    return data;
  } catch (ex) {
    throw ex;
  }
};

export const getHolidayPhotoUploadURL = reqData => async () => {
  const query = _mMutationBuilder.getMutationAsString(
    'getHolidayPhotoUploadURL',
    reqData
  );

  try {
    const data = await SkRequest({
      data: {
        query,
      },
      method: 'POST',
    });
    return data;
  } catch (ex) {
    return ex;
  }
};

export const monoCreateHoliday = (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: CREATE_HOLIDAY,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoCreateHoliday',
        fileName,
      },
      'error'
    );
    return {
      error: parseGraphQLError(ex),
    };
  }
};

export const createHoliday = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msCreateHoliday,
      monoHandler: monoCreateHoliday,
      extraData: reqData,
    }
  );
};

export const monoUpdateHoliday = (_, reqData) => {
  try {
    return SkApolloRequest({
      params: {
        mutation: UPDATE_HOLIDAY,
        variables: reqData,
      },
      type: 'mutation',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoUpdateHolidy',
        fileName,
      },
      'error'
    );
    return {
      success: false,
      error: parseGraphQLError(ex),
    };
  }
};

export const updateHoliday = reqData => async () => {
  return actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      msHandler: msUpdateHoliday,
      monoHandler: monoUpdateHoliday,
      extraData: reqData,
    }
  );
};

export default fetchHolidays;
